import env from 'lib/env';

// Single source of truth for which `next` paths are forwarded through auth.
export function getForwardableNextPath(nextPath?: string): string | undefined {
  return nextPath?.startsWith('/app') ? nextPath : undefined;
}

// Resolve the redirect base at call time so the current browser origin is used,
// ensuring users stay on the domain they signed in from — e.g.
// dashboard.withbridge.com vs dashboard.bridge.xyz. On the server (no window) we
// fall back to the runtime DOMAIN env var.
export function buildAuthenticateURL(nextPath?: string, extraParams?: Record<string, string>): string {
  const origin = window?.origin || env.DOMAIN;
  const authenticateBase = `${origin}/authenticate`;
  const forwardableNext = getForwardableNextPath(nextPath);
  const query = new URLSearchParams({
    ...(forwardableNext ? { next: forwardableNext } : {}),
    ...extraParams,
  }).toString();
  return query ? `${authenticateBase}?${query}` : authenticateBase;
}

export function buildLoginPath(nextPath?: string | null): string {
  const forwardableNext = getForwardableNextPath(nextPath ?? undefined);
  return forwardableNext ? `/login?next=${encodeURIComponent(forwardableNext)}` : '/login';
}

export function buildMfaPath(nextPath?: string | null): string {
  return nextPath ? `/authenticate/mfa?next=${encodeURIComponent(nextPath)}` : '/authenticate/mfa';
}

export function buildOtpConfirmPath(email: string): string {
  return `/otp-confirm?email=${encodeURIComponent(email)}`;
}
